module.exports = __webpack_public_path__ + "img/slide3.4399e1c7.jpg";